var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9329 19.6788C16.2604 20.9789 14.1589 21.7531 11.8765 21.7531C6.42188 21.7531 2 17.3312 2 11.8765C2 6.42188 6.42188 2 11.8765 2C17.3312 2 21.7531 6.42188 21.7531 11.8765C21.7531 14.1589 20.9789 16.2604 19.6788 17.9329L21.6384 19.8925C22.1205 20.3746 22.1205 21.1563 21.6384 21.6384C21.1563 22.1205 20.3746 22.1205 19.8925 21.6384L17.9329 19.6788ZM19.2839 11.8765C19.2839 15.9675 15.9675 19.2839 11.8765 19.2839C7.78554 19.2839 4.46914 15.9675 4.46914 11.8765C4.46914 7.78554 7.78554 4.46914 11.8765 4.46914C15.9675 4.46914 19.2839 7.78554 19.2839 11.8765Z",
    fill: "#BBC0D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.15c1def5bef29152d0aafec8ee470c48.svg";
export { ForwardRef as ReactComponent };